import React from 'react';
import './ConfirmDialog.css';

const ConfirmDialog = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="confirm-dialog-overlay">
      <div className="confirm-dialog">
        <div className="confirm-dialog-header">
          <h3>Confirm Delete</h3>
        </div>
        <div className="confirm-dialog-content">
          <div className="confirm-dialog-icon">⚠️</div>
          <p>{message}</p>
        </div>
        <div className="confirm-dialog-footer">
          <button className="confirm-btn yes-btn" onClick={onConfirm}>
            Yes
          </button>
          <button className="confirm-btn no-btn" onClick={onCancel}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
